import { DataMap } from '@grapecity/wijmo.grid';
import { useEffect, useState } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import {
  AnalysisKind,
  AnalysisKinds,
  ComparisonKinds,
  ComparisonKind,
  isTanEmpty,
} from 'views/Analysis/analysisUtils';
import { useMaster } from 'context/MasterContext';
import { toInt } from 'utils/numberUtils';

// 分析（現場担当）
function AnalysisGenbaTan(props) {
  const master = useMaster();

  // 分析種別が相談件数かどうか
  const isSoudan = props.analysisKind == AnalysisKind.SOUDAN;

  // 相談件数の場合、現場担当が未設定のものは「商談中(+失注)」として表示する
  const unsetLabel = isSoudan ? '商談中(+失注)' : '（未設定）';

  var planerMap = new DataMap([...master.planer, { id: 0, name: unsetLabel }], 'id', 'name');

  const genbaKindLabels = {
    [AnalysisKind.KEIYAKU]: '施工件数',
    [AnalysisKind.KINGAKU]: '施工金額',
  };

  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKindBase = AnalysisKinds.find((x) => x.key == props.analysisKind);
  const analysisKind =
    analysisKindBase && genbaKindLabels[props.analysisKind]
      ? { ...analysisKindBase, value: genbaKindLabels[props.analysisKind] }
      : analysisKindBase;
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);
  // ポイント換算フラグ
  const [pointFlg, setPirntFlg] = useState(false);
  // 合計のキー名
  const [keyTotal, setKeyTotal] = useState('');

  // 集計項目
  const [summaryItems, setSummaryItems] = useState([]);
  useEffect(() => {
    const point = pointFlg ? '_POINT' : '';
    setKeyTotal(pointFlg ? 'POINT_GENBA_TOTAL' : 'TOTAL');
    if (props.quoteList.items.length >= 1) {
      let tanCds = new Set(
        Object.keys(props.quoteList.items[0])
          .filter((key) => key.includes(`_GENBA_TAN_CD_POINT`))
          .map((key) => {
            return key.split(`_GENBA_TAN_CD_POINT_`)[1];
          })
      );
      // 担当コードでソート
      tanCds = Array.from(tanCds).sort((a, b) => toInt(a) - toInt(b));
      // 前期・今期ともに0の担当は表示しない
      tanCds = tanCds.filter(
        (x) => !isTanEmpty(props.quoteList.items, analysisKind?.prefix ?? '', 'GENBA_TAN_CD', x)
      );
      setSummaryItems(
        Array.from(tanCds).map((x) => ({
          key: `GENBA_TAN_CD${point}_${x}`,
          label: planerMap.getDisplayValue(x),
        }))
      );
    } else {
      setSummaryItems([]);
    }
  }, [props.quoteList, pointFlg, props.analysisKind]);

  return (
    <>
      <Row>
        <Col md={4} className="ml-2">
          <label>
            <input
              style={{ transform: 'scale(1.5)' }}
              type="checkbox"
              checked={pointFlg}
              onChange={(e) => {
                setPirntFlg(e.target.checked);
              }}
            />
            &nbsp;&nbsp;ポイント換算
          </label>
          {pointFlg && (
            <>
              <label className="ml-4" style={{ color: 'red' }}>
                工事×１P
              </label>
              <label className="ml-3" style={{ color: 'red' }}>
                管理・小工事×２P
              </label>
            </>
          )}
        </Col>
      </Row>
      <AnalysisCategory
        analysisList={analysisList}
        selectedPeriod={selectedPeriod}
        summaryItems={summaryItems}
        analysisKind={analysisKind}
        comparisonKind={comparisonKind}
        categoryName="現場担当別"
        keyTotal={keyTotal}
        key2Css={comparisonKind.key === ComparisonKind.BIG_SMALL && pointFlg ? 'point2_cell' : null}
      />
    </>
  );
}
export default AnalysisGenbaTan;
